import $ from "jquery";
import gsap from "gsap";
import SplitText from "gsap/SplitText";

// Filters open close
const filtersTrigger = $(".section-work__filters-icon");
const filtersModal = $(".filters-modal");
const filterModalClose = $(".filters-modal__close, .filters-modal__underlay, .filters-modal__item");
const filterChars = SplitText.create(".filters-modal__item", {
  type: "lines, chars",
  charsClass: "char"
});

let filtersOpenTL = gsap.timeline({paused: true});
filtersOpenTL
  .fromTo(
    filtersModal,
    {
      opacity: 0,
      visibility: "hidden"
    }, {
      opacity: 1,
      visibility: "visible",
      duration: 0.05
    })
  .fromTo(
    filterChars.chars,
    {
      y: "105%"
    },
    {
      y: 0,
      stagger: 0.01,
      duration: 0.2
    }
  );

filtersTrigger.click(function () {
  filtersOpenTL.play()
});

filterModalClose.click(function () {
  filtersOpenTL.reverse()
});

// AJAX load more projects
const loadMoreBtn = $("#load-more-projects");
const skeleton = $("#skeleton");
const projects_container = $("#projects-container");
let current_page = 1;
let current_category_id = null;

function getProjects(page) {
  loadMoreBtn.prop("disabled", true);
  skeleton.removeClass('d-none');
  $.ajax({
    type: "POST",
    url: "/wp-admin/admin-ajax.php",
    data: {
      action: "get_projects",
      current_page: page,
      term_id: current_category_id,
    },
    success: function (data) {
      skeleton.addClass('d-none');
      if (page >= data.data.pages) {
        loadMoreBtn.hide();
      } else {
        loadMoreBtn.show();
      }
      current_page = page;
      projects_container.append(data.data.html);
      loadMoreBtn.prop("disabled", false);
    },
    error: function (err) {
      console.log(err);
    },
  });
}

loadMoreBtn.click(function () {
  getProjects(current_page + 1);
});

$("[data-filter-category-id]").click(function () {
  projects_container.empty();
  const id = $(this).data("filter-category-id");
  if (id === "all") {
    current_category_id = null;
  } else {
    current_category_id = id;
  }
  getProjects(1);
  $("[data-filter-category-id]").removeClass("active");
  $(`[data-filter-category-id="${id}"]`).addClass("active");
});
